export enum AccountSettingsMutationKey {
  DELETE_PUSH_NOTIFICATION_SUBSCRIPTION = 'delete-push-notification-subscription',
  PATCH_ACCOUNT_SETTINGS = 'patch-account-settings',
  PATCH_PUSH_NOTIFICATION_SUBSCRIPTION = 'patch-push-notification-subscription',
}
